/*
  get incident flow
  There's a lot of logic in relationships so we've broken them out into different flows so relationships-modal doesn't get too crowded
*/
import { defaultFieldLogic } from 'AppSrc/core/components/forms/form-base-components/data-structure/default-field-logic';
import {
  RT_INCIDENT,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { incidentReference } from './incident-reference';

const getIncidentFlow = (params = {}) => {
  const {
    relationshipTypeValue,
    // values,
    // formData,
    // touched,
    // userRoles,
    // sectionId,
    // // the form that exists outside of the modal form
    // outerFormData,
  } = params;


  const shouldRender = relationshipTypeValue === RT_INCIDENT;


  const currentFields = [];

  currentFields.push({
    ...defaultFieldLogic,
    componentData: incidentReference,


    shouldRender,
    shouldValidate: shouldRender,
    overwriteSubmit: {
      overwrite: !shouldRender,
      overwriteValue: null,
    },
  });

  return currentFields;
};

export {
  getIncidentFlow,
};



